import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'details-icon',
  templateUrl: './details-icon.component.html',
  styleUrls: ['./details-icon.component.css']
})
export class DetailsIconComponent implements OnInit {

  @Input() cssClass: string;
  @Input() routerLink: any;
  @Input() tooltip: string;

  constructor() { }

  ngOnInit() {
  }

}
